import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { emptyHistogram, toHistogram } from './histogram-helper';
import { HistogramList, LegendContainer, StyledHistogram } from './Histogram.styles';
import { HistogramEntry } from './HistogramEntry';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Histogram = ({
  onClick,
  dates
}) => {
  const {
    t
  } = useTranslation();
  const [histogram, setHistogram] = useState(emptyHistogram);
  useEffect(() => {
    setHistogram(toHistogram(dates, t));
  }, [dates, t]);
  return /*#__PURE__*/_jsxs(StyledHistogram, {
    "aria-hidden": true,
    children: [/*#__PURE__*/_jsx(HistogramList, {
      children: histogram.bars.map(item => /*#__PURE__*/_jsx(HistogramEntry, {
        histogram: histogram,
        item: item,
        onClick: () => onClick && onClick(item)
      }, item.from + item.to))
    }), /*#__PURE__*/_jsxs(LegendContainer, {
      children: [/*#__PURE__*/_jsx("legend", {
        children: histogram.from
      }), /*#__PURE__*/_jsx("legend", {
        children: histogram.to
      })]
    })]
  });
};